import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _59740e60 = () => interopDefault(import('../pages/error.vue' /* webpackChunkName: "pages/error" */))
const _0227216b = () => interopDefault(import('../pages/HealthCheck/Get.vue' /* webpackChunkName: "pages/HealthCheck/Get" */))
const _15adf02a = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _811b8a0a = () => interopDefault(import('../pages/_lang/404.html.vue' /* webpackChunkName: "pages/_lang/404.html" */))
const _59f989ab = () => interopDefault(import('../pages/_lang/privacy.html.vue' /* webpackChunkName: "pages/_lang/privacy.html" */))
const _41f01e38 = () => interopDefault(import('../pages/_lang/propfilter/index.vue' /* webpackChunkName: "pages/_lang/propfilter/index" */))
const _43dba216 = () => interopDefault(import('../pages/_lang/userlogin.html.vue' /* webpackChunkName: "pages/_lang/userlogin.html" */))
const _0cd2a814 = () => interopDefault(import('../pages/_lang/userreturn.html.vue' /* webpackChunkName: "pages/_lang/userreturn.html" */))
const _3edc0726 = () => interopDefault(import('../pages/_lang/api/apiTest.vue' /* webpackChunkName: "pages/_lang/api/apiTest" */))
const _b576901e = () => interopDefault(import('../pages/_lang/api/css3Test.vue' /* webpackChunkName: "pages/_lang/api/css3Test" */))
const _a3ecb194 = () => interopDefault(import('../pages/_lang/api/csstest.vue' /* webpackChunkName: "pages/_lang/api/csstest" */))
const _12674c1a = () => interopDefault(import('../pages/_lang/api/cssUse.vue' /* webpackChunkName: "pages/_lang/api/cssUse" */))
const _7532e4b0 = () => interopDefault(import('../pages/_lang/api/downloadgoogle.vue' /* webpackChunkName: "pages/_lang/api/downloadgoogle" */))
const _39edfa65 = () => interopDefault(import('../pages/_lang/api/log.vue' /* webpackChunkName: "pages/_lang/api/log" */))
const _56d28ece = () => interopDefault(import('../pages/_lang/api/outdata.vue' /* webpackChunkName: "pages/_lang/api/outdata" */))
const _c6c3a5ca = () => interopDefault(import('../pages/_lang/api/swipe.vue' /* webpackChunkName: "pages/_lang/api/swipe" */))
const _4a1048c1 = () => interopDefault(import('../pages/_lang/api/test.vue' /* webpackChunkName: "pages/_lang/api/test" */))
const _8897d728 = () => interopDefault(import('../pages/_lang/compare/search.vue' /* webpackChunkName: "pages/_lang/compare/search" */))
const _332bc15f = () => interopDefault(import('../pages/_lang/family/buttons.js' /* webpackChunkName: "pages/_lang/family/buttons" */))
const _47bef378 = () => interopDefault(import('../pages/_lang/api/woody/_id.vue' /* webpackChunkName: "pages/_lang/api/woody/_id" */))
const _03af185a = () => interopDefault(import('../pages/_lang/compare/forex/_id.vue' /* webpackChunkName: "pages/_lang/compare/forex/_id" */))
const _d615cd72 = () => interopDefault(import('../pages/_lang/checkRobot/_id.vue' /* webpackChunkName: "pages/_lang/checkRobot/_id" */))
const _69635e3e = () => interopDefault(import('../pages/_lang/company/_id.vue' /* webpackChunkName: "pages/_lang/company/_id" */))
const _b59f12b4 = () => interopDefault(import('../pages/_lang/compare/_id.vue' /* webpackChunkName: "pages/_lang/compare/_id" */))
const _4069a233 = () => interopDefault(import('../pages/_lang/employee/_id.vue' /* webpackChunkName: "pages/_lang/employee/_id" */))
const _8d6b2d2e = () => interopDefault(import('../pages/_lang/family/_id.vue' /* webpackChunkName: "pages/_lang/family/_id" */))
const _58e65c3a = () => interopDefault(import('../pages/_lang/propcompare/_id.vue' /* webpackChunkName: "pages/_lang/propcompare/_id" */))
const _2b97145c = () => interopDefault(import('../pages/_lang/softwareDetails/_id.vue' /* webpackChunkName: "pages/_lang/softwareDetails/_id" */))
const _5827578f = () => interopDefault(import('../pages/_lang/word/_id.vue' /* webpackChunkName: "pages/_lang/word/_id" */))
const _92459c3a = () => interopDefault(import('../pages/_lang/404.html' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _59740e60,
    name: "error"
  }, {
    path: "/HealthCheck/Get",
    component: _0227216b,
    name: "HealthCheck-Get"
  }, {
    path: "/",
    component: _15adf02a,
    name: "index"
  }, {
    path: "/:lang/404.html",
    component: _811b8a0a,
    name: "lang-404.html"
  }, {
    path: "/:lang/privacy.html",
    component: _59f989ab,
    name: "lang-privacy.html"
  }, {
    path: "/:lang/propfilter",
    component: _41f01e38,
    name: "lang-propfilter"
  }, {
    path: "/:lang/userlogin.html",
    component: _43dba216,
    name: "lang-userlogin.html"
  }, {
    path: "/:lang/userreturn.html",
    component: _0cd2a814,
    name: "lang-userreturn.html"
  }, {
    path: "/:lang/api/apiTest",
    component: _3edc0726,
    name: "lang-api-apiTest"
  }, {
    path: "/:lang/api/css3Test",
    component: _b576901e,
    name: "lang-api-css3Test"
  }, {
    path: "/:lang/api/csstest",
    component: _a3ecb194,
    name: "lang-api-csstest"
  }, {
    path: "/:lang/api/cssUse",
    component: _12674c1a,
    name: "lang-api-cssUse"
  }, {
    path: "/:lang/api/downloadgoogle",
    component: _7532e4b0,
    name: "lang-api-downloadgoogle"
  }, {
    path: "/:lang/api/log",
    component: _39edfa65,
    name: "lang-api-log"
  }, {
    path: "/:lang/api/outdata",
    component: _56d28ece,
    name: "lang-api-outdata"
  }, {
    path: "/:lang/api/swipe",
    component: _c6c3a5ca,
    name: "lang-api-swipe"
  }, {
    path: "/:lang/api/test",
    component: _4a1048c1,
    name: "lang-api-test"
  }, {
    path: "/:lang/compare/search",
    component: _8897d728,
    name: "lang-compare-search"
  }, {
    path: "/:lang/family/buttons",
    component: _332bc15f,
    name: "lang-family-buttons"
  }, {
    path: "/:lang/api/woody/:id?",
    component: _47bef378,
    name: "lang-api-woody-id"
  }, {
    path: "/:lang/compare/forex/:id?",
    component: _03af185a,
    name: "lang-compare-forex-id"
  }, {
    path: "/:lang/checkRobot/:id?",
    component: _d615cd72,
    name: "lang-checkRobot-id"
  }, {
    path: "/:lang/company/:id?",
    component: _69635e3e,
    name: "lang-company-id"
  }, {
    path: "/:lang/compare/:id?",
    component: _b59f12b4,
    name: "lang-compare-id"
  }, {
    path: "/:lang/employee/:id?",
    component: _4069a233,
    name: "lang-employee-id"
  }, {
    path: "/:lang/family/:id?",
    component: _8d6b2d2e,
    name: "lang-family-id"
  }, {
    path: "/:lang/propcompare/:id?",
    component: _58e65c3a,
    name: "lang-propcompare-id"
  }, {
    path: "/:lang/softwareDetails/:id?",
    component: _2b97145c,
    name: "lang-softwareDetails-id"
  }, {
    path: "/:lang/word/:id?",
    component: _5827578f,
    name: "lang-word-id"
  }, {
    path: "/:lang/*",
    component: _92459c3a,
    name: "404.html"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
